import React from 'react';

const SVG = ({ children, style, className, width, height, viewBox }) => (
  <svg
    fill="currentColor"
    preserveAspectRatio="xMidYMid meet"
    className={className}
    width={width}
    height={height}
    viewBox={viewBox}
    style={{
      verticalAlign: 'middle',
      ...style
    }}
  >
    {children}
  </svg>
);

export default SVG;
